const route = {
	path: ':idCompany/:codeCompany-:nameCompany/edit',
	name: 'page-edit-company',
	meta: {
		title: 'Editar Compañía',
	},
	props: true,
	component: () => import('@/pages/companies/page-company-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/companies-edit.js